import { render } from "./EnterpriseStandardDetail.vue?vue&type=template&id=5c850ab5&scoped=true"
import script from "./EnterpriseStandardDetail.vue?vue&type=script&lang=js"
export * from "./EnterpriseStandardDetail.vue?vue&type=script&lang=js"

import "./EnterpriseStandardDetail.vue?vue&type=style&index=0&id=5c850ab5&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c850ab5"]])

export default __exports__